import { lockErrorKind, lockErrorMessage } from "../../locks/services/LockService";

import { ISpaceService } from "../services/SpaceService";
import { Space } from "../models/Space";

/** One space as a screen shows it: loading, the space, a 404 (hidden or gone: Not found), Identity unavailable, another error. */
export type SpaceState =
    | { status: "loading" }
    | { status: "ready"; space: Space }
    | { status: "not-found" }
    | { status: "identity-unavailable" }
    | { status: "error"; message: string };

/** `GET api/Spaces/{id}` as a `SpaceState` (never rejects). */
export function fetchSpaceState(service: ISpaceService, spaceId: string): Promise<SpaceState> {
    return service.getById(spaceId).then(
        (space): SpaceState => ({ status: "ready", space }),
        (err): SpaceState => {
            const kind = lockErrorKind(err);
            if (kind === "not-found") return { status: "not-found" };
            if (kind === "identity-unavailable") return { status: "identity-unavailable" };
            return { status: "error", message: lockErrorMessage(err) };
        }
    );
}
